import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "../../assets/style/sidebar.css";

const Sidebar = ({ isOpen, closeSidebar }) => {
  const location = useLocation();
  const isActive = (path) => (location.pathname === path ? "active" : "");
  const [user, setUser] = useState(null);

  const handleLinkClick = () => {
    if (window.innerWidth < 768) {
      closeSidebar();
    }
  };

  useEffect(() => {
    const userRaw = localStorage.getItem("user");
    try {
      const user = userRaw ? JSON.parse(userRaw) : null;
      setUser(user);
    } catch (e) {
      console.error("Erreur lors de la lecture du user dans le localStorage :", e);
    }
  }, []);


  return (
    <div className={`sidebar ${isOpen ? "show" : "hide"}`}>
      <button className="btn-close-sidebar d-md-none" onClick={closeSidebar}>✖</button>

      <div className="menu-section">
        <Link to="/usage/list" className={`menu-item ${isActive("/usage/list")}`} onClick={handleLinkClick}>
          📊 Liste journalière
        </Link>
        <Link to="/usage/now" className={`menu-item ${isActive("/usage/now")}`} onClick={handleLinkClick}>
          ⏳ Usage actuelle
        </Link>
      </div>

      {
        user && user?.role === 1 && (
          <div className="menu-section">
            <Link to="/user/list" className={`menu-item ${isActive("/user/list")}`} onClick={handleLinkClick}>
              👤 Liste des utilisateurs
            </Link>
            <Link to="/user/create" className={`menu-item ${isActive("/user/create")}`} onClick={handleLinkClick}>
              ➕ Créer un utilisateur
            </Link>
          </div>
        )
      }


    </div>

  );
};

export default Sidebar;
